import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../../Loner";
import {gsap} from "gsap";
import {LonerSymbol} from "../../../reels/symbols/main/LonerSymbol";
import {LonerStatics} from "../../../LonerStatics";
import {
    LonerBigWildPresentationSymbol2x2
} from "../../../reels/symbols/main/bigsymbols/LonerBigWildPresentationSymbol2x2";
import {
    LonerBigWildPresentationSymbol3x3
} from "../../../reels/symbols/main/bigsymbols/LonerBigWildPresentationSymbol3x3";
import {LonerSymbolStates} from "../../../../core/reel/ReelInterfaces";

export class LonerXSplitPresentation implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;
    private _controller:SimplePresentationRunnerController;

    constructor() {
    }

    public shouldRun():boolean {
        return Loner.model.xSplitInfo.length > 0;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;

        this._mainTL = gsap.timeline({
            onComplete : () => {
                this.complete();
            }
        });
        this._mainTL.add(() => controller.setSkipCallback(() => this.skip()));

        if(Loner.model.scatterTransform[4] == LonerSymbolStates.SCATTER_XSPLIT) {
            this._mainTL.add(gsap.timeline({delay : 0.1}));
        }

        for(let i:number = 0; i < Loner.model.xSplitInfo.length; i++) {
            const subTL:gsap.core.Timeline = gsap.timeline();
            let reel:number = Loner.model.xSplitInfo[i].pos[0];
            let row:number = Loner.model.xSplitInfo[i].pos[1];

            subTL.add(() => {
                Loner.scatterPool.getScatterSymbolOnReel(reel).getSplitTL()
            });
            subTL.add(gsap.timeline({delay : 0.17}));

            if(reel == 0) {
                //One Split FROM LEFT to right
                for(let j:number = 1; j < LonerStatics.REEL_NUMBERS; j++) {
                    if(j > 1) {
                        subTL.add(gsap.timeline({delay : 0.09}));
                    }
                    subTL.add(() => {
                        const symbol:LonerSymbol = (<LonerSymbol>Loner.allReelView.mainReelModels[j].reelView.symbols[row + 3]);
                        if(symbol.bigSymbolPart == true && symbol.reelPosition !== Loner.model.bigWildReelPosition) {
                            if(symbol.reelId == Loner.model.bigWildSize) {
                                if(Loner.model.bigWildSize == 2) {
                                    (<LonerBigWildPresentationSymbol2x2>Loner.wildSymbolPool.getActivePresentationBigWild()).getSplitSymbolTL();
                                } else {
                                    (<LonerBigWildPresentationSymbol3x3>Loner.wildSymbolPool.getActivePresentationBigWild()).getSplitSymbolTL();
                                }
                            }
                        } else if(symbol.bigSymbolPart == false && symbol.reelPosition == Loner.model.bigWildReelPosition && symbol.reelId == Loner.model.bigWildSize) {
                            if(Loner.model.bigWildSize == 2) {
                                (<LonerBigWildPresentationSymbol2x2>Loner.wildSymbolPool.getActivePresentationBigWild()).getSplitSymbolTL();
                            } else {
                                (<LonerBigWildPresentationSymbol3x3>Loner.wildSymbolPool.getActivePresentationBigWild()).getSplitSymbolTL();
                            }
                        } else {
                            symbol.getSplitSymbolTL(symbol.splitLevel *= 2);
                        }
                    });
                }
            }
            if(reel == 2) {
                //One Split FROM MIDDLE to left and right
                subTL.add(() => {
                    (<LonerSymbol>Loner.allReelView.mainReelModels[1].reelView.symbols[row + 3]).getSplitSymbolTL();
                    (<LonerSymbol>Loner.allReelView.mainReelModels[3].reelView.symbols[row + 3]).getSplitSymbolTL();
                });
                subTL.add(gsap.timeline({delay : 0.09}));
                subTL.add(() => {
                    (<LonerSymbol>Loner.allReelView.mainReelModels[0].reelView.symbols[row + 3]).getSplitSymbolTL();
                    (<LonerSymbol>Loner.allReelView.mainReelModels[4].reelView.symbols[row + 3]).getSplitSymbolTL();
                });
            }

            if(reel == 4) {
                //One Split FROM RIGHT to left
                for(let j:number = LonerStatics.REEL_NUMBERS - 2; j > -1; j--) {
                    if(j < LonerStatics.REEL_NUMBERS - 2) {
                        subTL.add(gsap.timeline({delay : 0.09}));
                    }
                    subTL.add(() => {
                        const symbol:LonerSymbol = (<LonerSymbol>Loner.allReelView.mainReelModels[j].reelView.symbols[row + 3]);
                        if(symbol.bigSymbolPart == true && symbol.reelPosition !== Loner.model.bigWildReelPosition) {
                            if(symbol.reelId == Loner.model.bigWildSize) {
                                if(Loner.model.bigWildSize == 2) {
                                    (<LonerBigWildPresentationSymbol2x2>Loner.wildSymbolPool.getActivePresentationBigWild()).getSplitSymbolTL();
                                } else {
                                    (<LonerBigWildPresentationSymbol3x3>Loner.wildSymbolPool.getActivePresentationBigWild()).getSplitSymbolTL();
                                }
                            }
                        } else if(symbol.bigSymbolPart == false && symbol.reelPosition == Loner.model.bigWildReelPosition && symbol.reelId == Loner.model.bigWildSize) {
                            if(Loner.model.bigWildSize == 2) {
                                (<LonerBigWildPresentationSymbol2x2>Loner.wildSymbolPool.getActivePresentationBigWild()).getSplitSymbolTL();
                            } else {
                                (<LonerBigWildPresentationSymbol3x3>Loner.wildSymbolPool.getActivePresentationBigWild()).getSplitSymbolTL();
                            }
                        } else {
                            symbol.getSplitSymbolTL(symbol.splitLevel *= 2);
                        }
                    });
                }
            }
            this._mainTL.add(subTL);
        }
        if(Loner.autoPlayPlugin.isAutoplayRound == true && Loner.model.betWayWins.length == 0) {
            this._mainTL.add(gsap.timeline({delay : 0.4}));
        }
    }

    private skip():void {
        this._mainTL.totalProgress(1);
    }

    private complete():void {
        this._controller.finish();
    }
}